<template>
	<div class="app--engagement-documents app--engagement-groups page-content">
		<div class="app--engagement-group bg--group border--group">
			<div class="group-heading" v-if="documents.length == 0 && pending">
				<span class="title" :class="theme('title')">{{ trans('documents.title') }}</span>
				<span class="description" :class="theme('description')">{{ trans('documents.processing') }}</span>
			</div>
			<div v-if="documents.length == 0 && pending" class="group-content multiple engagement-document">
				<div class="d-flex p-1 justify-content-center" :class="theme('rows')">
					<div class="small">{{ trans('documents.unavailable') }}</div>
				</div>
			</div>
			<div class="group-heading" v-if="documents.length > 0">
				<span class="title" :class="theme('title')">{{ trans('documents.title') }}</span>
				<span class="description" :class="theme('description')">{{ trans('documents.description') }}</span>
			</div>
			<div v-for="d in documents" class="group-content multiple engagement-document">
				<div class="group-row" :class="theme('rows')">
					<div class="title">{{ title(d) }}</div>
					<div class="btn-group">
						<a :href="download(d)" class="primary app--button border--button"
							:title="trans('documents.download')">
							{{ trans('documents.download') }}
						</a>
						<a v-if="preview && shouldCertify(d)" :href="certify(d)" class="primary app--button border--button"
							:title="trans('documents.download')">
							Certificate
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from '../../store'

export default {
	computed: {
		pending() {
			return store.state.signature_pending
		},
		documents() {
			let docs = []
			store.state.signatures.filter(s => s.filename != null).forEach(d => {
				let element = store.state.template.elements.find(e => e.id == d.definition)
				if (element && element.options.scope) {
					if (element.options.scope == 'FORM') {
						docs.push(d)
					}
					if (element.options.scope == 'PANEL' && !docs.find(i => i.panel == d.panel && i.definition == d.definition)) {
						docs.push(d)
					}
					if (element.options.scope == 'GROUP') {
						docs.push(d)
					}
				}
			});

			return docs
		},
		preview() {
			return store.state.preview === true
		}
	},
	methods: {
		trans(value) { let trans = store.getters.trans(value); return trans ? trans : this.$t('front.' + value) },
		theme(key) {
			return [
				'text--color-' + store.state.theme.groups[key].color,
				'text--font-' + store.state.theme.groups[key].font,
				'text--size-' + store.state.theme.groups[key].size,
			]
		},
		title(d) {
			let title = store.state.template.title
			let element = store.state.template.elements.find(e => e.id == d.definition)
			if (element && element.options && element.options.scope && element.options.scope != 'FORM') {
				let group = store.state.template.groups.find(g => g.id == element.group)
				let panel = store.state.template.panels.find(p => p.id == group.panel)
				if (element.options.scope == 'GROUP' && group && panel) {
					let accountPanel = store.state.panels.find(p => p.id == d.panel)
					let accountGroup = store.state.groups.find(g => g.id == d.group)
					return this.groupTitle(group, accountGroup, accountPanel) //+ ' (' + d.name + ')'
				}
				if (element.options.scope == 'PANEL' && panel) {
					return panel.title //+ ' (' + d.name + ')'
				}

			}
			return store.state.template.title //+ ' (' + d.name + ')'
		},
		download(d) {
			let path = this.preview ? '/app/engagements/signed/' : '/e/media/signed/'
			return path + store.state.id + '/' + d.definition + '/' + d.filename
		},
		shouldCertify(d) {
			let el = store.state.template.elements.find(e => e.id == d.definition)
			if (el && el.options && el.options.certify == true) {
				return true
			}
			return false
		},
		certify(d) {
			let path = '/app/engagements/certificate/'
			return path + store.state.id + '/' + d.definition + '/' + d.filename
		},
		groupTitle(d, g, p) {
			if (!d.row) {
				return d.title
			}
			let element = store.getters['dataElement'](p, g, { id: d.row })
			if (!element) {
				return d.title
			}
			let formatted = store.getters['elementFormatted'](element)
			return formatted ? formatted : d.title
		},
	},
	components: {}
}
</script>
